export default __webpack_public_path__ + "static/media/situation-mention-role-create.af4e724f.gif";